export const environment = {
  production: false,
  environment: 'testing',
  client: 'parker-app',
  apiUrl: 'https://api.testing.smartparking.jjames.eu',
  paymentAppUrl: 'https://payment.testing.jjames.eu',
  auth: {
    authority: 'https://auth.testing.smartparking.jjames.eu',
    realm: 'jjames',
    clientId: 'jjames-parker-frontend',
    clientBackend: 'jjames-backend',
    jkuIdpAlias: 'keycloak-oidc'
  },
  // Testing points at the real Keycloak, so real JKU SSO sessions are used.
  jku: {
    simulateSsoUser: false,
    simulatedUserType: ''
  }
};
